import React from "react";
import { Link2Off } from "lucide-react";
import { useTranslation } from "react-i18next";

export function InvalidSessionPage() {
  const { t } = useTranslation();

  return (
    <section className="kyc-flow-card kyc-surface mx-auto my-auto flex w-[calc(100%-1.5rem)] max-w-3xl flex-col justify-center rounded-3xl border border-white/10 bg-white px-6 py-14 text-center sm:px-10">
      <span className="mx-auto flex size-16 items-center justify-center rounded-2xl bg-slate-100 text-slate-700 ring-1 ring-slate-200">
        <Link2Off className="size-7" aria-hidden="true" />
      </span>
      <h1 className="mt-7 text-[1.75rem] font-semibold leading-tight tracking-[-0.035em] text-slate-950">
        {t("kyc.portal.invalidTitle")}
      </h1>
      <p className="mx-auto mt-3 max-w-md text-sm leading-6 text-slate-600">
        {t("kyc.portal.invalidText")}
      </p>
    </section>
  );
}
